// Aviso fixo no topo quando a internet cai (P0.9). Some sozinho ao reconectar.
import { useTranslation } from 'react-i18next';
import { useAppState } from '../state/AppStore';
import { Icon } from './Icon';

export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useAppState((s) => s.online);
  if (online) return null;
  return (
    <div className="banner banner--offline" role="status" data-testid="offline-banner">
      <Icon name="wifiOff" size={15} />
      <span>{t('offline.message')}</span>
    </div>
  );
}
